var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSignUpGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.3726 5.3726 0 12 0s12 5.3726 12 12-5.3726 12-12 12S0 18.6274 0 12zm11.9827-3.1893c.975 0 1.6327.4217 2.0077.7742l1.4655-1.4329c-.9-.8378-2.0712-1.352-3.4732-1.352-2.0309 0-3.7848 1.1671-4.6386 2.8658-.352.7049-.554 1.4964-.554 2.3342 0 .8378.202 1.6293.554 2.3342l1.6846-1.3058-1.6789 1.3058c.8539 1.6987 2.602 2.8658 4.6329 2.8658 1.402 0 2.5789-.4622 3.4386-1.2596.9808-.9071 1.5462-2.2417 1.5462-3.8248 0-.4276-.0346-.7396-.1096-1.0632h-4.8752v1.9298h2.8616c-.0577.4796-.3692 1.2018-1.0616 1.6871-.4384.3063-1.0269.52-1.8.52-1.3731 0-2.5386-.9071-2.954-2.1609-.1096-.3235-.173-.6702-.173-1.0284 0-.3582.0634-.7049.1673-1.0284.4211-1.2538 1.5866-2.161 2.9597-2.161z",
    fill: "#ED0D6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignUpGoogle);
export default __webpack_public_path__ + "static/media/Icon-Sign-Up-Google.4b7f7d1cc7f62be2bbe8ff7622e189c7.svg";
export { ForwardRef as ReactComponent };